import { Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

export const HeaderTitle = () => {
  const dictionary = Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby];

  const isDesktop = useIsDesktop();
  return (
    <>
      <Typography
        fontWeight={700}
        fontSize={'28px'}
        variant='h2'
        component={'h1'}
        mt={2}
        tabIndex={0}
      >
        {dictionary.createOrder.title}
      </Typography>
      <Typography variant='body3' mt={isDesktop ? 2 : 1} tabIndex={0}>
        {dictionary.createOrder.subtitle}
      </Typography>
    </>
  );
};
